var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-empty-state-wrapper" },
    [
      _c("font-awesome-icon", {
        class: _vm.iconClass,
        attrs: { icon: _vm.icon },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "message", style: _vm.messageStyle }, [
        _vm._v(_vm._s(_vm.message)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }